import React from 'react';
import { useNavigate } from 'react-router-dom';

const DemandesTable = ({ demandes, projects, onDemandeSelect, pagination, onPageChange }) => {
  const navigate = useNavigate();
  // Formater la date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Formater le statut
  const getStatusBadge = (demande) => {
    if (demande.has_technician) {
      return <span className="badge bg-success">Technicien assigné</span>;
    } else if (demande.need_technician) {
      return <span className="badge bg-warning">En attente</span>;
    } else {
      return <span className="badge bg-secondary">Non assigné</span>;
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        {demandes.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">Aucune demande trouvée</p>
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>Nom du demandeur</th>
                    <th>Email</th>
                    <th>Projet</th>
                    <th>Étape</th>
                    <th>Adresse</th>
                    <th>Statut</th>
                    <th>Date de soumission</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {demandes.map((demande) => (
                    <tr key={demande.id}>
                      <td>
                        <span className="fw-bold">#{demande.id}</span>
                      </td>
                      <td>
                        <div>
                          <div className="fw-semibold">{demande.name || 'N/A'}</div>
                          {demande.numero_tel && (
                            <small className="text-muted">
                              <i className="fas fa-phone me-1"></i>
                              {demande.numero_tel}
                            </small>
                          )}
                        </div>
                      </td>
                      <td>
                        <a 
                          href={`mailto:${demande.email}`}
                          className="text-decoration-none"
                        >
                          {demande.email || 'N/A'}
                        </a>
                      </td>
                      <td>
                        <div>
                          <span className="badge bg-info">
                            {demande.projet ? projects[demande.projet] || `Projet #${demande.projet}` : 'N/A'}
                          </span>
                          {demande.projet && (
                            <small className="text-muted d-block">
                              ID: {demande.projet}
                            </small>
                          )}
                        </div>
                      </td>
                      <td>
                        <span className="text-truncate d-inline-block" style={{maxWidth: '150px'}}>
                          {demande.project_step || 'N/A'}
                        </span>
                      </td>
                      <td>
                        <div className="text-truncate" style={{maxWidth: '200px'}}>
                          {demande.adresse || 'N/A'}
                        </div>
                        {demande.post_code && (
                          <small className="text-muted">
                            {demande.post_code}
                          </small>
                        )}
                      </td>
                      <td>
                        {getStatusBadge(demande)}
                      </td>
                      <td>
                        <small className="text-muted">
                          {formatDate(demande.submitted_at)}
                        </small>
                      </td>
                      <td>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => navigate(`/demande/${demande.id}`)}
                          title="Voir les détails"
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pagination.count > 0 && (
              <nav aria-label="Pagination des demandes">
                <ul className="pagination justify-content-center">
                  <li className={`page-item ${!pagination.previous ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => onPageChange(pagination.currentPage - 1)}
                      disabled={!pagination.previous}
                    >
                      Précédent
                    </button>
                  </li>
                  
                  {/* Affichage des numéros de page */}
                  {Array.from({ length: Math.ceil(pagination.count / 10) }, (_, i) => i + 1)
                    .filter(page => {
                      const current = pagination.currentPage;
                      return page === 1 || page === Math.ceil(pagination.count / 10) || 
                             (page >= current - 2 && page <= current + 2);
                    })
                    .map((page, index, array) => {
                      // Ajouter des points de suspension si nécessaire
                      const showEllipsis = index > 0 && page - array[index - 1] > 1;
                      return (
                        <React.Fragment key={page}>
                          {showEllipsis && (
                            <li className="page-item disabled">
                              <span className="page-link">...</span>
                            </li>
                          )}
                          <li className={`page-item ${page === pagination.currentPage ? 'active' : ''}`}>
                            <button
                              className="page-link"
                              onClick={() => onPageChange(page)}
                            >
                              {page}
                            </button>
                          </li>
                        </React.Fragment>
                      );
                    })}
                  
                  <li className={`page-item ${!pagination.next ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => onPageChange(pagination.currentPage + 1)}
                      disabled={!pagination.next}
                    >
                      Suivant
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DemandesTable;